import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AccordionItemPanel } from 'src/components/common/Accordion';
import AccordionItem from 'src/components/common/Accordion/components/AccordionItem';
import AccordionItemHeader from 'src/components/common/Accordion/components/AccordionItemHeader';
import OrgTree from 'src/components/common/OrgTree';
import { CHECKBOX_MODE } from 'src/components/common/OrgTree/types';
import { CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/constants';
import { useCreateActionItemContext } from 'src/components/myFollowUp/MyFollowUpPage/CreateMyFollowUpModal/CreateActionItemContext';

import useSelectOrgUnit from './useSelectOrgUnit';

const SelectOrgUnit: FC = () => {
  const { t } = useTranslation('myFollowUp');

  const {
    selectedOrgUnitNames,
    surveyId,
    orgTreeState,
    data,
    generateFetchChildrenEndpoint,
  } = useSelectOrgUnit();

  const { followUpActionModuleId } = useCreateActionItemContext();

  return (
    <AccordionItem itemName={CREATE_FOLLOW_UP_MODAL_ACCORDION_NAMES.ORG_UNIT}>
      <AccordionItemHeader
        headline={t('orgUnit.selectLabel')}
        selectedValueToShow={selectedOrgUnitNames}
      />
      <AccordionItemPanel disableAnimation>
        {surveyId ? (
          <OrgTree
            orgTreeState={orgTreeState}
            checkboxMode={CHECKBOX_MODE.MULTI}
            initialOrgUnits={data?.results}
            customFetchChildrenEndpoint={generateFetchChildrenEndpoint}
            surveyIdOverride={surveyId}
            showPriorityLabels
            syncWithFilter={false}
            moduleId={followUpActionModuleId}
          />
        ) : (
          <div>{t('orgUnit.selectSurveyFirst')}</div>
        )}
      </AccordionItemPanel>
    </AccordionItem>
  );
};

export default SelectOrgUnit;
